import { render } from "./ChangePicture.vue?vue&type=template&id=46e97b36&scoped=true"
import script from "./ChangePicture.vue?vue&type=script&lang=js"
export * from "./ChangePicture.vue?vue&type=script&lang=js"

import "./ChangePicture.vue?vue&type=style&index=0&id=46e97b36&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e97b36"]])

export default __exports__